import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FormsPageRoutingModule } from './forms-routing.module';

import { FormsPage } from './forms.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormDetailsComponent } from './form-details/form-details.component';
import { SharedDirectivesModule } from 'src/app/directives/shared-directives.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FormsPageRoutingModule,
    ComponentsModule,
    SharedDirectivesModule,
    TranslateModule
  ],
  declarations: [FormsPage, FormDetailsComponent],
})
export class FormsPageModule {}
